import { render } from "./OrderSupplierIndex.vue?vue&type=template&id=19d7ee4c&scoped=true"
import script from "./OrderSupplierIndex.vue?vue&type=script&lang=js"
export * from "./OrderSupplierIndex.vue?vue&type=script&lang=js"

import "./OrderSupplierIndex.vue?vue&type=style&index=0&id=19d7ee4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d7ee4c"]])

export default __exports__